__turbopack_context__.v({
  "section": "Hero-module__eHsoxW__section",
  "tile": "Hero-module__eHsoxW__tile",
  "tilePicture": "Hero-module__eHsoxW__tilePicture",
  "tileSide": "Hero-module__eHsoxW__tileSide",
  "tiles": "Hero-module__eHsoxW__tiles",
  "title": "Hero-module__eHsoxW__title",
});
